import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
  [ModulesConfigMap[ModulesMap.REPORTS_FINANCE_BY_SERVICES].GET_REPORTS_FINANCE_BY_SERVICES]: {
    url: '/company/:companyId/reports/finance/by_services/',
  },
}